export const SIMPLE_DATA = [
	{
		id: 0,
		question:
			'about.us.question.1',
		answer: 'about.us.answer.1',
	},
	{
		id: 1,
		question: 'about.us.question.2',
		answer: `about.us.answer.2`,
	},
	{
		id: 2,
		question:
			'about.us.question.3',
		answer: 'about.us.answer.3',
	},
	{
		id: 3,
		question:
			'about.us.question.4',
		answer: 'about.us.answer.4',
	},
	{
		id: 4,
		question:
			'about.us.question.5',
		answer: 'about.us.answer.5',
	},
];
